import { Outlet } from "react-router-dom";
import { PageTitle } from "@/components/PageTitle";

export function MainLayout() {
  return (
    <div className="min-h-screen bg-[var(--color-bg-base)] flex items-center justify-center p-4">
      <PageTitle />
      <Outlet />
    </div>
  );
}
